import { ICompanyContext, ICompanyContextUpdate } from '../../resource/company-contexts/company-contexts.types';
import { IApiRequestConfig } from '../api.types';

export const getCompanyContextsApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getCompanyContexts',
  uri: 'json',
  action: 'company-contexts',
  method: 'get',
  v2: true,
});

export const createCompanyContextApi = (companyToolsCategoryId: string): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'createCompanyContext',
  uri: 'json',
  action: 'company-contexts',
  method: 'post',
  data: { companyToolsCategoryId },
  v2: true,
});

export const updateCompanyContextApi = (
  companyContextId: ICompanyContext['id'],
  data: ICompanyContextUpdate,
): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updateCompanyContext',
  uri: 'json',
  action: `company-contexts/${companyContextId}`,
  method: 'patch',
  data,
  v2: true,
});

export const deleteCompanyContextApi = (companyContextId: ICompanyContext['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'deleteCompanyContext',
  uri: 'json',
  action: `company-contexts/${companyContextId}`,
  method: 'delete',
  v2: true,
});
